import { createReducer, on } from "@ngrx/store";
import * as FocusActions from "./focus.actions";

export const focusFeatureKey = "focus";

export interface State {
  focus: string;
}

export const initialFocusState: State = {
  focus: null,
};

export const focusReducer = createReducer(
  initialFocusState,
  on(FocusActions.setFocus, (state, { focus }) => ({ ...state, focus })),
);
